module.exports = __webpack_public_path__ + "img/andritz.95bca319.svg";